import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Index.vue'
import system from './system'
import store from '../store'
import recordManage from './recordManage'
import oiltabkManage from './oiltabkManage'
import cpyManage from './cpyManage'
import invoiceManage from './invoiceManage.js'
import grainSpecifications from './grainSpecifications.js'
import grainType from './grainType.js'
import userBond from './userBond.js'
import bondRecord from './bondRecord.js'
import orderManage from './orderManage.js'
import deliveryOrder from './deliveryOrder.js'
import priceControl from './priceControl.js'
import oilTankCost from './oilTankCost.js'
import customerOilStorage from './customerOilStorage.js'
import rentManage from './rentManage.js'
import flowManage from './flowManage.js'
import cyCrkManage from './cyCrkManage.js'
import inspectionPoint from './inspectionPoint.js'
import inspectionRecord from './inspectionRecord.js'
import patrolProblemReport from './patrolProblemReport.js'
import qualityControlReport from './qualityControlReport.js'
import technologicalInnovation from './technologicalInnovation.js'
import greenEnergy from './greenEnergy.js'
import expenseManage from './expenseManage.js'
import accessory from './accessory.js'
import ingredients from './ingredients.js'
import productionProcess from './productionProcess.js'
import vehicleManage from './vehicleManage.js'
import vehicleAccess from './vehicleAccess.js'
import equipmentLedger from './equipmentLedger.js'
import fireLedger from './fireLedger.js'
import firefightingClockIn from './firefightingClockIn.js'
import specialEquipment from './specialEquipment.js'
import materialsManage from './materialsManage.js'
import tenderDocument from './tenderDocument.js'
import purchaseOrders from './purchaseOrders.js'
import purchaseDelivery from './purchaseDelivery.js'
import purchaseInvoice from './purchaseInvoice.js'
import supplier from './supplier.js'
import eventRecord from './eventRecord.js'
import rawMaterialSupplier from './rawMaterialSupplier.js'
import supplierPayment from './supplierPayment.js'
import wspb from './wspb.js'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const constantRoutes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: (data) => {
      return '/schoolCompany/company'
    },
    children: [
      {
        path: '/orderstatistics',
        meta: { title: '订餐统计' },
        component: () => import('@/views/entryplan/OrderStatistics')
      },
      {
        path: '/cartimeconfig',
        meta: {
          title: '入场时间配置'
        },
        component: () => import('@/views/timeconfig/CarTimeConfig')
      },
      {
        path: '/entryplan',
        meta: { title: '入厂计划' },
        component: () => import('@/views/entryplan/EntryPlan.vue')
      },
      {
        path: '/mentryplan2',
        meta: { title: '车辆签到' },
        component: () => import('@/views/entryplan/EntryPlan2.vue')
      },
      {
        path: '/mentryplan3',
        meta: { title: '储运确认' },
        component: () => import('@/views/entryplan/EntryPlan3.vue')
      },
      {
        path: '/mentryplan4',
        meta: { title: '客服确认' },
        component: () => import('@/views/entryplan/EntryPlan4.vue')
      },
      {
        path: '/entryplan/add',
        meta: { title: '新增入厂计划' },
        component: () => import('@/views/entryplan/EntryPlanAdd.vue')
      },
      {
        path: '/entryplan/edit',
        meta: { title: '编辑入厂计划' },
        component: () => import('@/views/entryplan/EntryPlanAdd.vue')
      },
      {
        path: '/entryplan/detail',
        meta: { title: '入厂计划详情' },
        component: () => import('@/views/entryplan/EntryPlanDetail.vue')
      },
      {
        path: '/plansetting',
        meta: { title: '生产计划' },
        component: () => import('@/views/plansetting/PlanSetting.vue')
      },
      {
        path: '/plansetting/add',
        meta: { title: '新增生产计划' },
        component: () => import('@/views/plansetting/PlanSettingAdd.vue')
      },
      {
        path: '/plansetting/edit',
        meta: { title: '编辑生产计划' },
        component: () => import('@/views/plansetting/PlanSettingAdd.vue')
      },
      {
        path: '/plansetting/detail',
        meta: { title: '生产计划详情' },
        component: () => import('@/views/plansetting/PlanSettingDetail.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/Index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }

]

const asyncRoutes = [
  ...system, // 系统管理
  ...recordManage, // 收发油
  ...oiltabkManage, // 油罐
  ...cpyManage, // 成品油
  ...invoiceManage,
  ...grainSpecifications, // 粮油规格
  ...grainType, // 粮油类型
  ...userBond, // 保证金
  ...bondRecord, // 保证金退还充值记录
  ...orderManage, // 锁价订单
  ...deliveryOrder, // 提货订单
  ...priceControl, // 价格管理
  ...oilTankCost, // 油罐费用
  ...customerOilStorage, // 客户存油
  ...rentManage, // 租金管理
  ...flowManage, // 流程管理
  ...cyCrkManage, // 储运出入库
  ...inspectionPoint, // 巡检点位
  ...inspectionRecord, // 巡检记录
  ...patrolProblemReport, // 问题上报
  ...qualityControlReport, // 品控报告
  ...technologicalInnovation, // 技术创新
  ...greenEnergy, // 绿色能源
  ...expenseManage, // 费用管理
  ...accessory, // 辅料入厂验收
  ...ingredients, // 原料入厂验收
  ...productionProcess, // 生产过程检查
  ...vehicleManage, // 车辆管理
  ...vehicleAccess, // 车辆出入厂
  ...equipmentLedger, // 设备台账
  ...fireLedger, // 消防台账
  ...firefightingClockIn, // 消防打卡
  ...specialEquipment, // 特种设备管理
  ...materialsManage, // 物料管理
  ...tenderDocument, // 标书管理
  ...purchaseOrders, // 采购订单
  ...purchaseDelivery, // 采购订单提货
  ...purchaseInvoice, // 采购单发票
  ...supplier, // 供应商
  ...eventRecord, // 事件记录
  ...rawMaterialSupplier, // 原料供应商
  ...supplierPayment, // 供应商付款管理
  ...wspb, // 卫生评比
  {
    path: '/waitcarenter',
    meta: { title: '车辆进厂记录' },
    component: () => import('@/views/carrecord/CarRecord.vue')
  },
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  routes: constantRoutes.concat(asyncRoutes)
})

const whiteList = ['/waitcarenter', '/entryplan2']
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    if (store.state.token || whiteList.includes(to.path)) {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})

export default router
